import { formatQuoteNumber } from "@forgepoint/shared";
import { Badge } from "@/components/ui/badge";
import {
  useQuoteNumberPadWidth,
  useQuoteNumberPrefix,
} from "@/store/quoteSettingsStore";

interface OpportunityQuoteBadgesProps {
  quoteNumbers: number[];
}

/**
 * Renders one badge per quote number on an opportunity card, formatted with the
 * organization's quote-number prefix/pad settings (e.g. "#QA0055"). Renders
 * nothing when the opportunity has no quotes.
 * @param quoteNumbers - The opportunity's distinct quote numbers
 */
export function OpportunityQuoteBadges({
  quoteNumbers,
}: OpportunityQuoteBadgesProps) {
  const padWidth = useQuoteNumberPadWidth();
  const prefix = useQuoteNumberPrefix();

  if (quoteNumbers.length === 0) {
    return null;
  }

  return (
    <div className="flex flex-wrap gap-1 mt-1">
      {quoteNumbers.map((quoteNumber) => (
        <Badge
          key={quoteNumber}
          variant="secondary"
          className="text-xs tabular-nums font-normal"
        >
          #{formatQuoteNumber(quoteNumber, padWidth, prefix)}
        </Badge>
      ))}
    </div>
  );
}
